<div #queueCounterContainer class="gridItemChildModule w-100 h-100 d-flex justify-content-center" style="overflow: auto;">
    <app-module-error *ngIf="somethingWentWrong && !IsLoadingData"></app-module-error>
    <!-- Queue Counter widget shouldn't show the no data error and instead should just show the zero data -->
    <!-- <app-module-error class="flex-fill" *ngIf="noData && !moduleManager.showLoader && !IsLoadingData" [noData]="true"></app-module-error> -->
    <div class="h-100 w-100 scalingFontBlock" *ngIf="data && !somethingWentWrong">
        <div id="borderPadding" class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
            <div id="bothInQueue" class="blueCXOne scalingTextTruncate" title="{{ getQueueInfo() }}">
                {{ getQueueInfo() }}
            </div>
            <div id="contactsInQueue" class="bold blackCXOne scalingTextTruncate text-uppercase" title="{{ getContactsInQueueLocal() }}" cvLocalizedText langSection="Queue_Counter" langKey="Contacts_In_Queue">
                CONTACTS IN QUEUE
            </div>
            <div id="longestQueueTimeBoth" class="blueCXOne scalingTextTruncate" title="{{ getLongestQueueTime() }}">
                {{ getLongestQueueTime() }}
            </div>
            <div id="longestWaitingTime" class="blackCXOne scalingTextTruncate" title="{{ getLongestWaitingTimeLocal() }}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Waiting_Time">
                Longest waiting time
            </div>
        </div>
    </div>
</div>